import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h1>In Checkout Page</h1>
        </div>
    );
};

export default Checkout;